// Grit's floating tab bar: a frosted capsule clear of the iPhone home bar, with a
// soft fade behind it so content never pokes out underneath.

const ITEMS = [
  { route: 'home',     label: 'Today',    icon: todayIcon() },
  { route: 'progress', label: 'Progress', icon: progressIcon() },
  { route: 'food',     label: 'Food',     icon: foodIcon() },
  { route: 'weight',   label: 'Weight',   icon: weightIcon() },
  { route: 'settings', label: 'Settings', icon: gearIcon() },
];

export function renderNav(activeRoute) {
  return `
    <div class="grit-tabbar-fade" aria-hidden="true"></div>
    <nav class="grit-tabbar" aria-label="Main">
      ${ITEMS.map((i) => {
        const on = i.route === activeRoute;
        return `<a href="#/${i.route}" class="grit-tab ${on ? 'on' : ''}" ${on ? 'aria-current="page"' : ''}>
          <span class="w-6 h-6">${i.icon}</span>
          <span>${i.label}</span>
        </a>`;
      }).join('')}
    </nav>`;
}

function todayIcon() {
  return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="3.5"/><line x1="3" y1="9.5" x2="21" y2="9.5"/>
    <line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/>
  </svg>`;
}
function progressIcon() {
  return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M3 3v18h18"/><path d="M7 15l4-5 3.5 3L20 6.5"/>
  </svg>`;
}
function weightIcon() {
  return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="4.5"/><path d="M12 8.5l3 4"/><circle cx="12" cy="13.5" r="0.6"/>
  </svg>`;
}
function foodIcon() {
  return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M5 3v7a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2V3"/><line x1="7" y1="12" x2="7" y2="21"/>
    <path d="M17 3c-1.4 0-2.3 1.9-2.3 4.5S15.6 12 17 12s2.3-1.9 2.3-4.5S18.4 3 17 3z"/><line x1="17" y1="12" x2="17" y2="21"/>
  </svg>`;
}
function gearIcon() {
  return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
  </svg>`;
}
